import ImmutablePropTypes from 'react-immutable-proptypes';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { fromJS } from 'immutable';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function ObjectPreview({
  field
}) {
  if (field && !field.get) {
    field = fromJS(field);
  }
  return _jsx(WidgetPreviewContainer, {
    children: field && field.get('fields') || field.get('field') || null
  });
}
ObjectPreview.propTypes = {
  field: ImmutablePropTypes.map
};
export default ObjectPreview;